import { useContext } from "react";
import {
    Box,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    Typography,
} from "@mui/material";
import { RestaurantContext } from "src/Utils/Context/RestaurantContext";
import { colorBorder, colorSurface, colorTextMuted, radiusCard, shadowCard } from "src/design/tokens";

interface Props {
    restaurantId: string;
    onRestaurantChange: (id: string) => void;
    replace: boolean;
    onReplaceChange: (value: boolean) => void;
}

const RestaurantAndOptionsBar = ({ restaurantId, onRestaurantChange, replace, onReplaceChange }: Props) => {
    const { restaurants, isLoading } = useContext(RestaurantContext);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                p: 2,
                backgroundColor: colorSurface,
                border: `1px solid ${colorBorder}`,
                borderRadius: radiusCard,
                boxShadow: shadowCard,
            }}
        >
            <FormControl size="small" sx={{ minWidth: 280 }} disabled={isLoading}>
                <InputLabel>Restaurant</InputLabel>
                <Select
                    value={restaurantId}
                    label="Restaurant"
                    onChange={(e) => onRestaurantChange(e.target.value)}
                >
                    {restaurants.map((r) => (
                        <MenuItem key={r.id} value={r.id}>
                            {r.name}
                            <Typography variant="caption" sx={{ ml: 1, color: colorTextMuted }}>
                                — {r.city}
                            </Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={replace}
                            onChange={(e) => onReplaceChange(e.target.checked)}
                            size="small"
                        />
                    }
                    label={
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            Replace existing menu
                        </Typography>
                    }
                />
                <Typography variant="caption" sx={{ color: colorTextMuted, ml: 5 }}>
                    {replace
                        ? "Current menu will be wiped before import"
                        : "Entries will be appended to the current menu"}
                </Typography>
            </Box>
        </Box>
    );
};

export default RestaurantAndOptionsBar;
